import { Section, SlateNode } from '@all-hands-hq/plex-graphql-schema';

import { selectedSectionsReducer } from './selectedSectionsReducer';

export type DocumentToImportState = {
  externalEntityId: string;
  content: SlateNode[];
  document: Section;
  selectedSections: Set<Section>;
};

export type DocumentToImportAction =
  | {
      type: 'INIT';
      state: DocumentToImportState | undefined;
    }
  | {
      type: 'ROW_CLICK';
      section: Section;
    }
  | {
      type: 'CHECKBOX_CLICK';
      section: Section;
    }
  | {
      type: 'UPDATE_SELECTION';
      selectedSections: Section[];
    };

export const documentToImportReducer = (
  state: DocumentToImportState | undefined,
  action: DocumentToImportAction
): DocumentToImportState | undefined => {
  if (state != null) {
    switch (action.type) {
      case 'INIT': {
        return action.state;
      }

      case 'ROW_CLICK':
      case 'CHECKBOX_CLICK':
      case 'UPDATE_SELECTION': {
        return {
          ...state,
          selectedSections: selectedSectionsReducer(state.selectedSections, action),
        };
      }
    }
  } else if (action.type === 'INIT') {
    return action.state;
  } else {
    return state;
  }
};
